export default __webpack_public_path__ + "static/media/aligner_pl.8538f54d.png";